import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';

export const SatelliteIdFilter = props => {
  const {t} = useTranslation();
  return (
    <Box width="100%" py={2}>
      <Typography display="block" gutterBottom>
        {t('satelliteIdFilter.label', 'Satellite ID')}
      </Typography>
      <Typography variant="caption">
        {t('satelliteIdFilter.caption')}
      </Typography>
      <TextField
        size="small"
        variant="outlined"
        placeholder={t('satelliteIdFilter.inputPlaceholder')}
        fullWidth
        margin="dense"
        onChange={props.onChange}
        value={props.satelliteId}
      />
    </Box>
  );
};

SatelliteIdFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  satelliteId: PropTypes.string,
};

export default SatelliteIdFilter;
